/**
 * Pure helper that orders warehouses alphabetically (ABC) by name.
 *
 * Mirrors the admin helper (admin/src/utils/sortWarehouses.js): Hungarian
 * collation, case/accent-insensitive, numeric-aware ("R2" < "R10"). No React /
 * React-Native imports so it is unit-testable.
 */

let collator = null;

try {
    collator = new Intl.Collator('hu', {numeric: true, sensitivity: 'base'});
} catch (_error) {
    // Runtime without Intl.Collator — fall back to localeCompare below.
    collator = null;
}

const compareNames = (a, b) => {
    const left = String(a?.name ?? '');
    const right = String(b?.name ?? '');

    return collator ? collator.compare(left, right) : left.localeCompare(right);
};

/**
 * Returns a new array of warehouses ordered alphabetically by name.
 * Non-array input yields an empty array; the input is never mutated.
 *
 * @param {Array<{name?: string}>} warehouses Warehouse rows.
 * @returns {Array<object>} Sorted copy.
 */
export const sortWarehousesByName = (warehouses) => (
    Array.isArray(warehouses) ? [...warehouses].sort(compareNames) : []
);

export default sortWarehousesByName;
